<div class="offerNote mobile-hidden" *ngIf="offerNote && offerNote.text">
    <div [ngStyle]="{'background-image': 'url(' + offerNote.image + ')'}" class="hotelier"></div>
    <div class="saying">
        <span id="off-tex" *ngIf="offerNote">{{offerNote.text}}</span>
    </div>
</div>
<div class="row desktop-hidden">
    <div class="col-md-6 col-12 col-sm-12 personal offer-note" *ngIf="offerNote">
        <div class="hotelier float-left" [ngStyle]="{'background-image':'url(' +
                offerNote.image + ')'}">
        </div>
        <div class="hotelierNote float-left">
            <h4 class="">Host’s offer just for you ! </h4>
            <span>{{offerNote.text}}</span>
        </div>
    </div>
</div>

<ul class="exclusiveWrap mobile-hidden" *ngIf="extrasDates">
    <li *ngFor="let key of getKeys(extrasDates) | slice:0:3" id="extra_{{key}} " [ngClass]="extrasDates.get(key).color" (click)="changePeriod(key)">
        <a style="margin-left: 10px;"> <span>{{extrasDates.get(key).title}}</span></a>
    </li>
</ul>
<a *ngIf="!isExtrasVisible() && getKeys(extrasDates).length > 0 && getKeys(extrasDates).length > 2 && getKeys(extrasDates).length > 3" class="moreInfo" (click)="toggleExtrasVisibility()" style="margin-top:2px;">
    more  <span class="glyphicon glyphicon-chevron-down"></span>
</a>
<a *ngIf="isExtrasVisible() " class="moreInfo lessInfo" (click)="toggleExtrasVisibility()" style="margin-top:1px;">less</a>
<ul class="exclusiveWrap mobile-hidden" *ngIf="extrasDates" id="extr" style="display:none">
    <li *ngFor="let key of getKeys(extrasDates) | slice:3:end" id="extra_{{key}} " [ngClass]="extrasDates.get(key).color" (click)="changePeriod(key)">
        <a style="margin-left: 10px;"> <span>{{extrasDates.get(key).title}}</span></a>
    </li>
</ul>



